<template>
  <div class="app-layout">
    <Sidebar />
    <div class="main-content">
      <div class="payments-view">
        <PaymentsComponent />
      </div>
    </div>
  </div>
</template>

<script>
import PaymentsComponent from '@/components/PaymentsComponent.vue';
import Sidebar from '@/components/Sidebar.vue';

export default {
  name: 'PaymentsView',
  components: {
    PaymentsComponent,
    Sidebar
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  margin-left: 280px; /* Match sidebar width */
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.payments-view {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
}
</style> 